namespace TabAurous.Stock {
    export namespace SupplierPerformanceService {
        export const baseUrl = 'Stock/SupplierPerformance';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/SupplierPerformance/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>SupplierPerformanceService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
